// extracted by mini-css-extract-plugin
export default {"container":"HeroInput__container-JQKA","fadeOut":"HeroInput__fadeOut-mrGo"};